module.exports = require("react-copy-to-clipboard");


//////////////////
// WEBPACK FOOTER
// external "react-copy-to-clipboard"
// module id = 312
// module chunks = 0